// extracted by mini-css-extract-plugin
export default {"lostMoneyPillButtons":"LostMoney_lostMoneyPillButtons__Oz3Wv"};